var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"kefu"}},[_c('img',{staticClass:"kefu_img",attrs:{"src":require("../assets/zhishi327/kefu.png")},on:{"click":_vm.weiZixun}}),_c('img',{staticClass:"kefu_img",attrs:{"src":require("../assets/zhishi327/dianhua.png")},on:{"click":_vm.boZixun}})])
}
var staticRenderFns = []

export { render, staticRenderFns }